<mat-card>
    <mat-card-content>
        <div class="head" fxLayout="row">
            <div class="headTitle" fxFlex="30">
                <mat-card-title>
                    <!-- User Database -->
                    <title-back [addTitle]="true" [Title]="'User Database'" (back)="back()"></title-back>
                </mat-card-title>
            </div>
            <div class="headOption" fxFlex="70">
                <div class="records">
                    <mat-form-field appearance="outline">
                        <input matInput (ngModelChange)="applyFilter($event)" placeholder="Search" ngModel>
                        <i matSuffix class="flaticon-search"></i>
                    </mat-form-field>
                </div>
                <logzy-reports-table [downloadButtons]="true" [pageName]="'user_master'"></logzy-reports-table>
                <!-- <button class="Save downloadReport" mat-stroked-button [matMenuTriggerFor]="downloadReport"> <i
                        class="flaticon-download"></i> Reports</button> -->
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [(ngModel)]="userValue">
                    <mat-button-toggle value="internal_user" (click)="Show()">Internal User</mat-button-toggle>
                    <mat-button-toggle value="external_user" (click)="noShow()">External User</mat-button-toggle>
                </mat-button-toggle-group>
                <div *ngIf="isShown">
                    <!-- <button class="add" mat-raised-button (click)="openDD()"><i id=""
                            class="flaticon-add-user"></i></button> -->
                    <mat-button-toggle-group name="addingUsers" class="add" aria-label="Font Style">
                        <mat-button-toggle value="add_user" (click)="openUserSidePanel()">
                            <i id="" class="flaticon-add-user"></i>
                        </mat-button-toggle>
                        <!-- <mat-button-toggle value="add_users" (click)="this.isBulk = !this.isBulk;" [disabled]="true"> -->
                        <mat-button-toggle value="add_users" [disabled]="true">
                            <i id="" MatSuffix matTooltip="Feature Coming Soon..." matTooltipPosition="above"
                                matTooltipHideDelay="2000" class="flaticon-add-group"></i>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <!-- <mat-menu #downloadReport="matMenu" xPosition="before">
                    <button mat-menu-item>Stock Report</button>
                    <button mat-menu-item>Additional Report</button>
                </mat-menu> -->
            </div>
        </div>
        <div id="database" class="content" [class.hide]="isBulk" fxLayout="column">
            <logzy-table-loader *ngIf="loading"></logzy-table-loader>
            <ng-container *ngIf="!loading">
                <div fxFlex="100" class="table-responsive" *ngIf="isShown">
                    <ng-container *ngIf="!internalUserList?.data.length">
                        <logzy-billu part1="No " part2="entries " part3="here." font="14px"></logzy-billu>
                    </ng-container>
                    <ng-container *ngIf="internalUserList?.data.length">
                         <mat-table [dataSource]="internalUserList" matSort (matSortChange)="announceSortChange($event)">
                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                            <mat-cell *matCellDef="let user" (click)="viewUser(user)">
                                <logzy-img-loader (click)="viewUser(user)" src="{{user.picture==null?
                                        user.gender=='Male'?base_url+'/media/profile_pics/man.svg':
                                        user.gender=='Female'?base_url+'/media/profile_pics/woman.svg':
                                        base_url+'/media/profile_pics/default_dp.svg':user.picture?.document_file}}"
                                    alt="" border_radius="50%" [profilePic]="true" [initials]="user?.initials"
                                    [class.p-0]='true'></logzy-img-loader>
                                <span class="fullName" (click)="viewUser(user)">
                                    {{user.first_name}} {{user.last_name}}
                                </span>
                            </mat-cell>
                        </ng-container>
                        <!-- email Column -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
                            <mat-cell *matCellDef="let user" style="    word-break: break-all;">
                                {{user.email}}</mat-cell>
                        </ng-container>

                        <!-- Department Column -->
                        <ng-container matColumnDef="department">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Department </mat-header-cell>
                            <mat-cell *matCellDef="let user"> {{user.department?.name}}</mat-cell>
                        </ng-container>

                        <!-- role Column -->
                        <ng-container matColumnDef="role">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Role </mat-header-cell>
                            <mat-cell *matCellDef="let user">{{user.role?.name}} </mat-cell>
                        </ng-container>

                        <!-- status -->
                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                            <mat-cell *matCellDef="let user">
                                <span class="natureChip" [style.background]="user.user_status?.color_code" [style.color]="'#ffffff'"
                                    (click)="viewUser(user)">{{user.user_status?.description}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                            <mat-cell *matCellDef="let user; let i=index">
                                <button mat-icon-button [matMenuTriggerFor]="menu"
                                    aria-label="Example icon-button with a menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="viewUser(user)">
                                        <span>View Details</span>
                                    </button>
                                    <button mat-menu-item (click)="editUser(user)">
                                        <span>Edit Details</span>
                                    </button>
                                    <button mat-menu-item [disabled]="resetPassUids.indexOf(user.id) >= 0"
                                        (click)="reset(user)">
                                        <span>Reset Password</span>
                                    </button>
                                    <button mat-menu-item
                                        (click)="banUser(user,user.user_status?.dev_name=='banned'?false:true)">
                                        <span>{{user.user_status?.dev_name=='banned'?'Revoke Ban':'Ban User'}}</span>
                                    </button>
                                </mat-menu>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <!-- <div class="row"> -->
                        <mat-row *matRowDef="let user; columns: displayedColumns" [class.blur]="update"> </mat-row>
                        <!-- </div> -->
                        </mat-table>
                    </ng-container>

                    <div class="loadingData" [class.d-none]="!update">
                        <logzy-gear-loader></logzy-gear-loader>

                    </div>
                    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
                        aria-label="Select page of users" [length]="pageLength" (page)="pageChanged($event)">
                    </mat-paginator>
                </div>
                <div fxFlex="100" class="table-responsive" *ngIf="!isShown">
                    <ng-container *ngIf="!externalUserList?.data.length">
                        <logzy-billu part1="No " part2="entries " part3="here." font="14px"></logzy-billu>
                    </ng-container>
                    <ng-container *ngIf="externalUserList?.data.length">
                        <mat-table [dataSource]="externalUserList" matSort (matSortChange)="announceSortChange($event)">
                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                            <mat-cell *matCellDef="let user">
                                <logzy-img-loader (click)="viewUser(user)" src="{{user.picture==null?
                                        user.gender=='Male'?base_url+'/media/profile_pics/man.svg':
                                        user.gender=='Female'?base_url+'/media/profile_pics/woman.svg':
                                        base_url+'/media/profile_pics/default_dp.svg':user.picture?.document_file}}"
                                    alt="" border_radius="50%" [profilePic]="true" [initials]="user?.initials"
                                    [class.p-0]='true'></logzy-img-loader>
                                <span class="fullName">{{user.first_name}} {{user.last_name}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- email Column -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
                            <mat-cell *matCellDef="let user"> {{user.email}}</mat-cell>
                        </ng-container>

                        <!-- Company Column -->
                        <ng-container matColumnDef="company">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Company </mat-header-cell>
                            <mat-cell *matCellDef="let user">{{user.company?.name??'-'}} </mat-cell>
                        </ng-container>

                        <!-- Mobile number Column -->
                        <ng-container matColumnDef="mobile_number">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Mobile Number </mat-header-cell>
                            <mat-cell *matCellDef="let user">{{user?.mobile_number?.as_e164}} </mat-cell>
                        </ng-container>

                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
                            <mat-cell *matCellDef="let user; let i=index">
                                <!-- [matMenuTriggerFor]="menu" -->
                                <!-- <button mat-icon-button aria-label="Example icon-button with a menu">
                                    <mat-icon [matTooltip]="'Feature coming soon'">more_vert</mat-icon>
                                </button> -->
                                <!-- <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="viewUser(user)">
                                        <span>View Details</span>
                                    </button>
                                    <button mat-menu-item (click)="editUser(user)">
                                        <span>Edit Details</span>
                                    </button>
                                    <button mat-menu-item [disabled]="clickedOnReset" (click)="reset(user)">
                                        <span>Reset Password</span>
                                    </button>
                                    <button mat-menu-item
                                        (click)="banUser(user,user.user_status?.dev_name=='banned'?false:true)">
                                        <span>{{user.user_status?.dev_name=='banned'?'Revoke Ban':'Ban User'}}</span>
                                    </button>
                                </mat-menu> -->
                                <div class="actions">
                                    <i class="flaticon-view"></i>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
                        <mat-row *matRowDef="let user; columns: displayedColumns1" [class.blur]="update"> </mat-row>
                        </mat-table>
                    </ng-container>
                    <div class="loadingData" [class.d-none]="!update">
                        <logzy-gear-loader></logzy-gear-loader>
                    </div>
                    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
                        aria-label="Select page of users" [length]="pageLength" (page)="pageChanged($event)">
                    </mat-paginator>
                    <!-- <div *ngIf="!isShown" class="nodata">
                        <logzy-billu part1="No " part2="Data " part3="Found" font="14px"></logzy-billu>
                    </div> -->
                </div>
            </ng-container>
        </div>
        <div id="bulk" class="bulk" [class.unhide]="isBulk">
            <div class="content1 form-group" id="card2" fxLayout="column wrap">
                <div class="headContent">
                    <span class="head"> <b> Download the format of excel file here </b></span> <img class="format"
                        src="assets/images/products/sheets.png" alt="Download Format" (click)="export()">
                </div>
                <div class="formContent" fxLayout="column wrap">
                    <ul>
                        <li>Add the data in the excel format as per the required format:</li>
                        <li>Once you have downloaded the excel sheet, take the POL/PODS from the third tab (Port
                            List) Please don’t enter the names yourself as that might not match master data. </li>
                        <li>Put only the 1st leg slot. Put che charge name “I Leg Slot”.</li>
                        <li>Don’t put any special characters in the Term field e.g. if term is CY/CY then only
                            mention CYCY.</li>
                        <li>Avoid putting any junk data/special characters in the excel sheet for the data read
                            operation to work properly.</li>
                        <li>Make sure you are not adding a data which is duplicated in sheet already exists in the
                            database</li>
                        <li>Do not change the column headings provided in the template. These need to be unchanged
                            the import to work in the next step</li>
                    </ul>
                    <div class="quantity" fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-md="65%">
                            <span> <b> Need more help?</b></span>
                            <br>
                            <span>Now, it’s easier than done. Help yourself the video tutorial</span><br>
                            <span>Cheers!</span>
                        </div>
                        <div class="video" fxFlex.gt-md="35%">
                            <iframe src="https://www.youtube.com/embed/4U5WBzqYbnc" title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                        </div>

                    </div>
                    <!-- <div class="btnb" fxFlex="100">
                        <button class="bck" mat-stroked-button routerLink="/dashboards/master-dashboard">Back</button>
                        <button class="nxt" mat-stroked-button (click)="bulkUpload()">
                            
                            Continue
                        </button>
                    </div> -->
                </div>
            </div>
            <div class="content1 form-group" id="card4" fxLayout="column wrap">
                <div class="headContent">
                    <span class="head"><b> Upload Data</b> </span>
                </div>
                <bulk-data></bulk-data>
                <div class="btnb1" fxFlex="100">
                    <button class="bck" mat-raised-button class="bck"
                        (click)="this.isBulk = !this.isBulk;">Cancel</button>
                    <button class="nxt" mat-stroked-button (click)="this.isBulk = !this.isBulk;">Save
                        Upload</button>
                </div>
            </div>
            <!-- <button mat-raised-button (click)="this.isBulk = !this.isBulk;"> view</button> -->
        </div>
    </mat-card-content>
</mat-card>